//wordpress dependencies
import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
//internal dependencies
import Edit from "./edit";
import example from "./example";
import icons from "../../util/RTCLGB-icon-controls/icons"

registerBlockType("rtcl/pricing-table", {
	title: __("Pricing Table", "classified-listing"),
	description: __("classified listing pricing table", "classified-listing"),
	category: "classified-list-gb",
	icon: {
		src: icons.rtclLogo,
	},
	keywords: [
		__("listing pricing table", "classified-listing"),
		__("table", "classified-listing"),
		__("classified-listing", "classified-listing"),
	],
	edit: Edit,
	save: () => null,
	//example,
});